var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sys-teacher-hub-modal",
    {
      attrs: {
        show: _vm.localShow,
        title: "Perfil do Docente",
        "max-width": "980",
      },
      on: {
        "update:show": function ($event) {
          _vm.localShow = $event
        },
      },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "pa-8 text-center" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary", size: "48" },
                  }),
                  _c("p", { staticClass: "mt-4 mb-0 text-body-1 grey--text" }, [
                    _vm._v("Carregando perfil..."),
                  ]),
                ],
                1
              )
            : _vm.errorMessage
            ? _c(
                "v-alert",
                {
                  staticClass: "ma-4",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
              )
            : _vm.profileTeacher
            ? _c(
                "div",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-2" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center align-start",
                          attrs: { cols: "12", md: "3" },
                        },
                        [
                          _c("emc-avatar-teacher", {
                            attrs: {
                              model: _vm.profileTeacher,
                              token: _vm.token || "",
                              "show-menu": true,
                              width: "96",
                              height: "96",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "9" } },
                        [
                          _c(
                            "div",
                            { staticClass: "text-h6 font-weight-bold" },
                            [_vm._v(_vm._s(_vm.profileTeacher.name))]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-body-1 text--secondary" },
                            [_vm._v(_vm._s(_vm.teacherTitulation))]
                          ),
                          _c("v-divider", { staticClass: "mt-4" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-overline font-weight-bold text--secondary",
                            },
                            [_vm._v("INFORMAÇÕES INSTITUCIONAIS")]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mb-2" },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-email-outline")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium mr-2" },
                                [_vm._v("E-mail:")]
                              ),
                              _c("span", [
                                _vm._v(_vm._s(_vm.institutionalEmail)),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-school-outline")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium mr-2" },
                                [_vm._v("Titulação:")]
                              ),
                              _c("span", [
                                _vm._v(_vm._s(_vm.teacherTitulation)),
                              ]),
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "my-4" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-overline font-weight-bold text--secondary",
                            },
                            [_vm._v("INFORMAÇÕES PESSOAIS")]
                          ),
                          _c(
                            "div",
                            { staticClass: "font-weight-medium mb-1" },
                            [_vm._v("Endereço")]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              outlined: "",
                              "prepend-inner-icon": "mdi-map-marker-outline",
                              value: _vm.formattedAddress,
                              readonly: "",
                              "hide-details": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-expansion-panels",
                    { staticClass: "mt-4", attrs: { multiple: "" } },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v(
                              " Atualização Cadastral (Telefones, Links e E-mails) "
                            ),
                          ]),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("sys-teacher-update-data", {
                                attrs: {
                                  model: _vm.profileTeacher,
                                  token: _vm.token,
                                },
                                on: { onComplete: _vm.handleComplete },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v(" Endereço "),
                          ]),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("sys-address-register", {
                                attrs: {
                                  model: _vm.profileTeacher,
                                  type: "teacher",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }